import { render, staticRenderFns } from "./app.coming.soon.vue?vue&type=template&id=67f75f82&scoped=true&"
import script from "./app.coming.soon.vue?vue&type=script&lang=js&"
export * from "./app.coming.soon.vue?vue&type=script&lang=js&"
import style0 from "./app.coming.soon.vue?vue&type=style&index=0&id=67f75f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f75f82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
